import React, { ReactNode } from 'react';

import { container } from '../../../../styles/themes';
import { textBodyLarge, textTitle3 } from '../../../../styles/typography';
import { classNames } from '../../../../utils/style';

export interface ClientContentProps {
  contentTitle?: string;
  children?: ReactNode;
}

export const ClientContent = ({
  contentTitle,
  children,
}: ClientContentProps) => {
  return (
    <div
      className={classNames(
        container,
        'lg:w-8/12 flex justify-end mb-48 lg:mb-104'
      )}
    >
      <div className="lg:w-3/4">
        <h3 className={classNames(textTitle3, 'font-medium mb-16 lg:mb-24')}>
          {contentTitle}
        </h3>
        <div className={classNames(textBodyLarge, 'text-neutral-301')}>
          {children}
        </div>
      </div>
    </div>
  );
};
